export const PLACEHOLDER_IMAGE =
  "https://res.cloudinary.com/dv6hrcluu/image/upload/v1709897247/web-app-images/my-g-work-small_nbamrj.svg";
export const WORKPRIDE_PLACEHOLDER_IMAGE =
  "https://res.cloudinary.com/dv6hrcluu/image/upload/v1736343240/2025-01-08_18-31_pzdsdj.png";
export const RESOURCE_CENTER_PLACEHOLDER_IMAGE =
  "https://res.cloudinary.com/dv6hrcluu/image/upload/f_auto/q_auto/resource-center/admin-icons/default-resource-image_npwht6.jpg";
export const NEWSLETTER_ARCHIVE_THUMBNAIL =
  "https://res.cloudinary.com/dv6hrcluu/image/upload/resource-center/newsletter_thumbnail_k2vex6";
/** PNG for Open Graph/social previews (Teams, Outlook) - SVG not supported by link preview crawlers */
export const OG_ARTICLE_PLACEHOLDER_IMAGE =
  "https://res.cloudinary.com/dv6hrcluu/image/upload/v1752165947/web-app-images/new-hero-image_kh85p7.png";
/** Homepage hero banner — Cloudinary asset; links to WorkPride */
export const HOMEPAGE_WORKPRIDE_HERO_IMAGE =
  "https://res.cloudinary.com/dv6hrcluu/image/upload/v1752165947/web-app-images/new-hero-image_kh85p7.png";

export const TRAINING_FOLDER_THUMBNAIL =
  "https://res.cloudinary.com/dv6hrcluu/image/upload/v1786357147/organization_shared_folder_default_covers/training_rg8hte.png";
